<template>
  <v-container>
    <v-row>
      <v-col
        cols="8"
        md="10"
      >
        <v-text-field
          v-model="keyword"
          label="Search"
          placeholder="Firstname, lastname, nickname, phone number, etc."
          outlined
          dense
          @keyup.enter="setSearchParam"
        />
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <v-btn
          class="mx-2"
          small
          exact
          @click="setSearchParam"
        >
          Search
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: 'Search',
  props: ['attribute_list'],
  data: () => ({
    keyword: '',
    previous_keyword: ''
  }),
  methods: {
    setSearchParam () {
      if (this.keyword != this.previous_keyword) {
        this.$emit('setSearchParam', `&keyword=${this.keyword}`)
      }
    }
  }
}
</script>